import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';

import { ProfileComponent } from '../../components/profile';
import { getServerTranslations } from '../../lib/i18n/getServerTranslations';

const ProfilePage = () => {
  const { t } = useTranslation('common');
  return (
    <>
      <h1 className="sr-only">{t('my_profile')}</h1>
      <ProfileComponent />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'onboarding-page', 'worker-references-page']);
  return {
    props: {
      ...transConfig,
    },
  };
};

export default ProfilePage;
